(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.fi = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Tietoja ei löydy'
      },
      combobox: {
        placeholder: 'Valitse',
        searchPlaceholder: 'Haku'
      },
      datepicker: {
        apply: 'Käytä',
        clearSelection: 'Tyhjennä',
        pickADays: 'Valitse päivät',
        prevYear: 'Edellinen vuosi',
        nextYear: 'Seuraava vuosi',
        prevMonth: 'Edellinen kuukausi',
        nextMonth: 'Seuraava kuukausi',
        year: '',
        month1: 'Tammikuu',
        month2: 'Helmikuu',
        month3: 'Maaliskuu',
        month4: 'Huhtikuu',
        month5: 'Toukokuu',
        month6: 'Kesäkuu',
        month7: 'Heinäkuu',
        month8: 'Elokuu',
        month9: 'Syyskuu',
        month10: 'Lokakuu',
        month11: 'Marraskuu',
        month12: 'Joulukuu',
        weeks: {
          sun: 'Su',
          mon: 'Ma',
          tue: 'Ti',
          wed: 'Ke',
          thu: 'To',
          fri: 'Pe',
          sat: 'La'
        },
        months: {
          jan: 'Tammi',
          feb: 'Helmi',
          mar: 'Maalis',
          apr: 'Huhti',
          may: 'Toukokuu',
          jun: 'Kesä',
          jul: 'Heinä',
          aug: 'Elo',
          sep: 'Syys',
          oct: 'Loka',
          nov: 'Marras',
          dec: 'Joulu'
        },
        pickADay: 'Valitse päivä'
      },
      timepicker: {
        meridiemAM: 'am',
        meridiemPM: 'pm'
      },
      dropdown: {
        noDataMessage: 'Tietoja ei löydy'
      },
      filepicker: {
        browse: 'Selaa',
        select: 'Valitse tiedosto'
      },
      filter: {
        apply: 'Käytä',
        cancel: 'Peruuta',
        filterButton: 'Suodatin',
        reset: 'Nollaa suodattimet',
        resetDefault: 'Palauta oletusarvoihin'
      },
      search: {
        noDataMessage: 'Tietoja ei löydy'
      },
      'multi-search': {
        'separator-and': 'JA',
        'search-button': 'Haku',
        'search-placeholder': 'Hae nimellä'
      },
      select: {
        all: 'Kaikki',
        clearSelection: 'Tyhjennä valinta',
        noMatch: 'Tietoja ei löydy',
        noData: 'Ei tietoja',
        placeholder: 'Valitse',
        item: 'kohde(tta)',
        selected: 'valittu',
        found: 'löytyi'
      },
      upload: {
        browseButton: 'Selaa',
        text: 'Vedä ja pudota ladattavat tiedostot tai napsauta Selaa',
        tip: 'Voit ladata 10 tiedostoa, joista kukin voi olla enintään 25 Mt'
      },
      table: {
        emptyText: 'Ei tietoja'
      },
      tree: {
        emptyText: 'Ei tietoja'
      }
    }
  };
  _exports.default = _default;
});